import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { useHistory, useLocation } from "react-router-dom";
import "./AppTopbar.scss";
import dp from '../src/assets/warehouse-assets/dp.jpeg'
import { baseURL } from "./Config";
import { Image } from "primereact/image";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_PROFILE } from "./redux/slices/authenticationSlice";
import toplogo from './assets/warehouse-assets/Trackall_Logo.png'
import { OverlayPanel } from 'primereact/overlaypanel';

export const AppTopbar = (props) => {

    const history = useHistory();
    const location = useLocation()
    const dispatch = useDispatch()

    const warehouseid = localStorage.getItem("warehouseid")
    const roletypeid = localStorage.getItem("roletypeid")
    const usertype_id = localStorage.getItem("usertype_id")
    const warehouse_name = localStorage.getItem("warehouse_name")
    const logo_img = localStorage.getItem("logo_img")

    const op = useRef(null);
    const img = useSelector((state) => state?.authenticationSlice?.img) || localStorage.getItem("img");
    const user_name = useSelector((state) => state?.authenticationSlice?.user_name) || localStorage.getItem("user_name");

    useEffect(() => {
        if (img || user_name) {
            dispatch(UPDATE_PROFILE(img || user_name));
        }
    }, [dispatch, img, user_name]);

    const handleIconClick = (event) => {
        op.current.toggle(event);
    };

    const accept = () => {
        localStorage.clear();
        localStorage.removeItem('lastActive');
        localStorage.removeItem("permissions");
        localStorage.removeItem("login");
        localStorage.removeItem("token");
        window.localStorage.clear();
        window.sessionStorage.clear();
        history.push("/");
    };

    const reject = () => {
        return null
    };

    const confirm1 = () => {
        confirmDialog({
            message: 'Are you sure you want to Logout?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };

    return (

        <>
            <div className="layout-topbar">
                <ConfirmDialog style={{ width: '500px' }} />
                <button type="button" className="p-link layout-menu-button layout-topbar-button ml-0" onClick={props.onToggleMenuClick}>
                    <i className="pi pi-bars" />
                </button>

                <div className="flex flex-column ml-2 text-center topbar-heading">
                    <h3 className="mt-3 ml-3" style={{ fontWeight: "bold" }}>
                        Grab and Eat
                    </h3>
                </div>

                <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                    <i className="pi pi-ellipsis-v" />
                </button>

                <OverlayPanel ref={op} dismissable>
                    <div style={{ padding: '2px' }} className="flex flex-column">
                        <p className="overlay-p" onClick={confirm1}>
                            <i className="pi pi-sign-out" style={{ marginRight: '8px' }}></i>
                            Logout
                        </p>
                    </div>
                </OverlayPanel>

                <ul className={classNames("layout-topbar-menu lg:flex origin-top", { "layout-topbar-menu-mobile-active": props.mobileTopbarMenuActive })}>
                    <li className="flex" style={{ alignItems: "center" }}>
                        <i className="pi pi-angle-down logout-red-color ml-4" onClick={handleIconClick} title="Logout" />
                    </li>
                </ul>
            </div>
        </>
    );
};
